import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS,
} from '@modules/general-settings/submodules/table-columns-settings/constants';

import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsTableColumnsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT_ROUTE_NAME,
      path: 'edit/:id/:localeKey',
      component: () => import('./pages/AdminGeneralSettingsTableColumnsEditPage/AdminGeneralSettingsTableColumnsEditPage.vue'),
      permission: [
        ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.EDIT,
        ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW_VERSIONS,
      ],
      meta: {
        hideParentModuleWrapper: true,
      },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT, getTranslationKeys);
  }
}
